<script lang="ts">
	export let title = ''
</script>

<div class="flex justify-center items-center w-screen h-screen">
	<div class="bg-white rounded small-board p-8">
		<h1 class="text-center font-bold text-xl">{title}</h1>
		<slot></slot>
  </div>
</div>

<style lang="postcss">
	.small-board {
		width: 400px;
	}
</style>